var z = function(e, r) {
  var o = e.getBoundingClientRect(), n = r.getBoundingClientRect(), f = Math.max(n.top, o.top), l = Math.max(n.left, o.left), s = Math.min(n.left + n.width, o.left + o.width), c = Math.min(n.top + n.height, o.top + o.height), h = s - l, m = c - f;
  if (l < s && f < c) {
    var U = n.width * n.height, w = o.width * o.height, v = h * m, x = v / (U + w - v);
    return Number(x.toFixed(4));
  }
  return 0;
}, D = function(e, r) {
  var o = 0, n = null;
  return r.forEach(function(f) {
    if (f && e) {
      var l = z(e, f);
      l > o && (o = l, n = f);
    }
  }), n;
}, F = function() {
  var e = window && window.navigator.userAgent;
  if (!e)
    return !1;
  var r = !1, o = [], n = {
    edge: /(edge)[ \/]([\w.]+)/i,
    webkit: /(chrome|crios)[ \/]([\w.]+)/i,
    safari: /(webkit)[ \/]([\w.]+)/i,
    opera: /(opera)(?:.*version|)[ \/]([\w.]+)/i,
    msie: /(msie\s|trident.*? rv:)([\w.]+)/i,
    mozilla: /(mozilla)(?:.*? rv:([\w.]+)|)/i
  };
  for (var f in n)
    if (n.hasOwnProperty(f) && (o = e.match(n[f]), o)) {
      r = {}, r[f] = !0, r[o[1].toLowerCase().split(" ")[0].split("/")[0]] = !0, r.version = parseInt(document.DOCUMENT_NODE || o[2], 10);
      break;
    }
  return r;
}, X = function(e) {
  return e && e.ownerDocument || window.document;
}, H = function(e) {
  var r = X(e);
  return r && r.defaultView || window;
}, Y = function(e) {
  var r = { browser: F() }, o = X(e);
  return r.browser.edge || r.browser.safari ? o.body : o.documentElement;
}, j = function(e) {
  if (e && e.className && typeof e.className == "string" && e.className.indexOf("k-auto-scrollable") > -1)
    return !0;
  var r = window.getComputedStyle(e, "overflow").overflow;
  return r.indexOf("auto") > -1 || r.indexOf("scroll") > -1;
}, C = function(e) {
  var r = Y(e);
  if (!e || e === document.body || e === document.documentElement)
    return r;
  for (var o = e; o && o !== document.body && o.nodeType !== Node.DOCUMENT_FRAGMENT_NODE && o.nodeType !== Node.DOCUMENT_NODE && !j(o); )
    o = o.parentNode;
  return o && (o === document.body || o.nodeType === Node.DOCUMENT_FRAGMENT_NODE) ? r : o;
}, q = function(e, r, o) {
  var n = { x: 0, y: 0 }, f = 50;
  return e - o.left < f ? n.x = -(f - (e - o.left)) : o.right - e < f && (n.x = f - (o.right - e)), r - o.top < f ? n.y = -(f - (r - o.top)) : o.bottom - r < f && (n.y = f - (o.bottom - r)), n;
}, J = function(e, r) {
  var o = Y(e);
  if (e === o)
    return {
      top: o.scrollTop,
      left: o.scrollLeft,
      bottom: o.scrollTop + r.innerHeight,
      right: o.scrollLeft + r.innerWidth
    };
  var n = e.getBoundingClientRect();
  return {
    bottom: n.top + n.height,
    right: n.left + n.width,
    left: n.left,
    top: n.top
  };
}, Q = function(e, r, o) {
  var n = o.getBoundingClientRect();
  return n.top <= r && n.left <= e && r <= n.bottom && e <= n.right;
}, t;
(function(e) {
  e.POINTER_DOWN = "pointerdown", e.POINTER_MOVE = "pointermove", e.POINTER_UP = "pointerup", e.POINTER_CANCEL = "pointercancel", e.MOUSE_DOWN = "mousedown", e.MOUSE_MOVE = "mousemove", e.MOUSE_UP = "mouseup", e.CONTEXT_MENU = "contextmenu", e.TOUCH_START = "touchstart", e.TOUCH_MOVE = "touchmove", e.TOUCH_END = "touchend", e.TOUCH_CANCEL = "touchcancel", e.SCROLL = "scroll", e.START = "KENDO_DRAG_AND_DROP_START", e.MOVE = "KENDO_DRAG_AND_DROP_MOVE", e.END = "KENDO_DRAG_AND_DROP_END", e.CANCEL = "KENDO_DRAG_AND_DROP_CANCEL";
})(t || (t = {}));
var Z = function(e) {
  return /^touch/.test(e.type);
}, $ = function(e) {
  return /^(scroll)/.test(e.type);
}, _ = function(e, r) {
  return Z(e) ? {
    pageX: e.changedTouches[0].pageX,
    pageY: e.changedTouches[0].pageY,
    clientX: e.changedTouches[0].clientX,
    clientY: e.changedTouches[0].clientY,
    scrollX: r.scrollOffset.x,
    scrollY: r.scrollOffset.y,
    offsetX: r.offset.x,
    offsetY: r.offset.y,
    type: e.type,
    originalEvent: e,
    isTouch: !0,
    altKey: !1,
    ctrlKey: !1,
    shiftKey: !1,
    metaKey: !1
  } : $(e) ? {
    pageX: r.pageOffset.x,
    pageY: r.pageOffset.y,
    clientX: r.clientOffset.x,
    clientY: r.clientOffset.y,
    scrollX: r.scrollOffset.x,
    scrollY: r.scrollOffset.y,
    offsetX: r.offset.x,
    offsetY: r.offset.y,
    type: e.type,
    originalEvent: e,
    altKey: !1,
    ctrlKey: !1,
    shiftKey: !1,
    metaKey: !1
  } : {
    pageX: e.pageX,
    pageY: e.pageY,
    clientX: e.clientX,
    clientY: e.clientY,
    offsetX: e.offsetX,
    offsetY: e.offsetY,
    scrollX: r.scrollOffset.x,
    scrollY: r.scrollOffset.y,
    type: e.type,
    ctrlKey: e.ctrlKey,
    shiftKey: e.shiftKey,
    altKey: e.altKey,
    metaKey: e.metaKey,
    originalEvent: e
  };
}, g = function() {
}, I = function(e, r, o) {
  o === void 0 && (o = {});
  var n = o.onIsPressedChange, f = n === void 0 ? g : n, l = o.onIsScrollingChange, s = l === void 0 ? g : l, c = o.onVelocityChange, h = c === void 0 ? g : c, m = o.onOffsetChange, U = m === void 0 ? g : m, w = o.onPageOffsetChange, v = w === void 0 ? g : w, x = o.onClientOffsetChange, S = x === void 0 ? g : x, K = o.onScrollOffsetChange, L = K === void 0 ? g : K, W = o.onInitialScrollOffsetChange, V = W === void 0 ? g : W, a = r.payload, d = a.element, R = a.hint, M = e.autoScrollDirection, N = e.scrollableParent, i = _(r.event, e);
  switch (i.type) {
    case t.POINTER_DOWN:
      if (i.type === t.POINTER_DOWN && (!i.originalEvent.isPrimary || i.originalEvent.button !== 0))
        break;
    case t.MOUSE_DOWN:
      if (i.type === t.MOUSE_DOWN && i.originalEvent.which && i.originalEvent.which > 1 || e.ignoreMouse)
        break;
    case t.TOUCH_START:
      if (i.type === t.TOUCH_START && i.originalEvent.touches.length !== 1)
        break;
    case t.START: {
      var p = N || C(r.payload.element);
      V(p instanceof Window ? { x: p.scrollX, y: p.scrollY } : { x: p.scrollLeft, y: p.scrollTop }), S({
        x: i.clientX,
        y: i.clientY
      }), v({
        x: i.pageX,
        y: i.pageY
      }), U({
        x: i.offsetX,
        y: i.offsetY
      }), f(!0), a.onPress && a.onPress(i);
      break;
    }
    case t.SCROLL:
      if (i.type === t.SCROLL && !e.pressed)
        break;
      var y = N || C(d), b = y instanceof Window ? { x: y.scrollX, y: y.scrollY } : { x: y.scrollLeft, y: y.scrollTop };
      i.scrollX = b.x - e.initialScrollOffset.x, i.scrollY = b.y - e.initialScrollOffset.y, L({
        x: i.scrollX,
        y: i.scrollY
      });
    case t.POINTER_MOVE:
      if (i.type === t.POINTER_MOVE && !i.originalEvent.isPrimary)
        break;
    case t.MOUSE_MOVE:
    case t.TOUCH_MOVE:
      if (i.type === t.TOUCH_MOVE && i.originalEvent.touches.length !== 1)
        break;
    case t.MOVE: {
      if (e.pressed) {
        if (e.autoScroll && i.originalEvent.type !== "scroll" && d) {
          var k = X(d), B = N || C(k.elementFromPoint(i.clientX, i.clientY)), T = q(i.clientX, i.clientY, J(B, H(d)));
          h({
            x: M && M.horizontal === !1 ? 0 : T.x,
            y: M && M.vertical === !1 ? 0 : T.y
          }), s(T.y !== 0 || T.x !== 0);
        }
        !e.drag && a.onDragStart && a.onDragStart(i), a.onDrag && a.onDrag(i);
        var E = D(R || d, e.drops.map(function(u) {
          return u && u.element;
        }).filter(function(u) {
          return u !== (R || d);
        })), O = e.drops.find(function(u) {
          return u.element === E;
        });
        O && E && Q(i.clientX, i.clientY, N || C(E)) && E !== d ? (e.drop && e.drop.element) !== E ? (e.drop && e.drop.onDragLeave && e.drop.onDragLeave(i), O.onDragEnter && O.onDragEnter(i)) : O.onDragOver && O.onDragOver(i) : e.drop && e.drop.onDragLeave && e.drop.onDragLeave(i);
      }
      S({
        x: i.clientX,
        y: i.clientY
      }), v({
        x: i.pageX,
        y: i.pageY
      });
      break;
    }
    case t.POINTER_UP:
      if (i.type === t.POINTER_UP && !i.originalEvent.isPrimary)
        break;
    case t.MOUSE_UP:
    case t.TOUCH_END:
      if (i.type === t.TOUCH_END && i.originalEvent.touches.length !== 1)
        break;
    case t.END: {
      f(!1), s(!1), L({ x: 0, y: 0 }), a.onRelease && a.onRelease(i), e.drop && e.drop.onDrop && e.drop.onDrop(i), e.drag && a.onDragEnd && a.onDragEnd(i);
      break;
    }
    case t.POINTER_CANCEL:
    case t.CONTEXT_MENU:
    case t.TOUCH_CANCEL:
    case t.CANCEL: {
      f(!1), s(!1), L({ x: 0, y: 0 }), a.onDragEnd && a.onDragEnd(i), e.drop && e.drop.onDragLeave && e.drop.onDragLeave(i);
      break;
    }
  }
}, G = function(e, r) {
  if (e) {
    var o, n, f = e === Y(e);
    f ? (o = document.body.scrollHeight > window.innerHeight, n = document.body.scrollWidth > window.innerWidth) : (o = e.offsetHeight <= e.scrollHeight, n = e.offsetWidth <= e.scrollWidth);
    var l = e.scrollTop + r.y, s = o && l > 0 && l < e.scrollHeight, c = e.scrollLeft + r.x, h = n && c > 0 && c < e.scrollWidth;
    s ? e.scrollTop += r.y : o && l < 0 && (e.scrollTop = 0), h ? e.scrollLeft += r.x : n && c < 0 && (e.scrollLeft = 0);
  }
};
export {
  G as a,
  I as d,
  C as g
};
